import React, { useState, useRef, useEffect } from 'react';
import { getDefaultPosition } from 'src/utils/dom';
import { logCustom } from 'src/utils/tracker';
import EntryImg from '../entry-img';
import './index.scss';
function getWidth(dom) {
    const width = parseInt(getComputedStyle(dom).width) || 0;
    return width > 0 ? width : 335;
}
export default function Entry(props) {
    const { onClick, children, contentVisible, panelVisible, position = 'bottom', direction = 'normal', panelCode, showEntry, autoHideEntry, otherEntryNode, } = props;
    const visible = contentVisible || panelVisible;
    const [contentPosition, setContentPosition] = useState([0, 0]);
    const [defaultPosition, setDefaultPosition] = useState(() => getDefaultPosition(position, 62, 12, direction));
    const moveRef = useRef(null);
    const containerRef = useRef(null);
    const contentRef = useRef(null);
    // 点击时不会触发该函数
    const handleDrag = (e) => {
        if (!e)
            return;
        // console.log('handleDrag', e);
        if (moveRef.current && contentRef.current && containerRef.current) {
            let rect = moveRef.current.getBoundingClientRect();
            const contentRect = contentRef.current.getBoundingClientRect();
            const containerRect = containerRef.current.getBoundingClientRect();
            const maxHeight = document.documentElement.clientHeight;
            const paddingTop = 12;
            // 超出顶部处理
            if (rect.top < 0) {
                setDefaultPosition({
                    x: e.x,
                    y: 0 - containerRect.top,
                });
                setContentPosition([
                    0,
                    0 - containerRect.top + paddingTop + rect.height + contentRect.height,
                ]);
                // 没过底部处理
            }
            else if (rect.top + rect.height > maxHeight) {
                // console.log(rect, maxHeight)
                setDefaultPosition({
                    x: e.x,
                    y: 0,
                });
            }
            else {
                // 正常处理
                setDefaultPosition({
                    x: e.x,
                    y: e?.y || 0,
                });
            }
        }
    };
    // 动态计算面板位置
    useEffect(() => {
        if (!visible)
            return;
        if (moveRef.current && contentRef.current && containerRef.current) {
            let rect = moveRef.current.getBoundingClientRect();
            const contentRect = contentRef.current.getBoundingClientRect();
            const containerRect = containerRef.current.getBoundingClientRect();
            const maxHeight = document.documentElement.clientHeight;
            const paddingTop = 12;
            // console.log('rect', rect, contentRect, containerRect);
            // 超出顶部处理
            if (rect.top < 0) {
                setContentPosition([
                    0,
                    0 - containerRect.top + paddingTop + rect.height + contentRect.height,
                ]);
                // 没过底部处理
            }
            else if (rect.top + rect.height > maxHeight) {
                setContentPosition([0, 0]);
                // console.log('max');
            }
            else {
                // 正常处理
                const offsetTop = rect.y - contentRect.height - paddingTop < 0
                    ? defaultPosition.y + rect.height + contentRect.height + paddingTop
                    : defaultPosition.y;
                setContentPosition([0, offsetTop]);
            }
        }
    }, [defaultPosition, children, contentVisible, panelVisible]);
    const contentChildWidth = contentRef.current?.firstElementChild
        ? getWidth(contentRef.current?.firstElementChild)
        : 335;
    // console.log('moveRef', moveRef, defaultPosition);
    return (React.createElement("div", { className: `cn-ui-intelli-assistant-area ${props.isOs ? 'os' : ''} ${!showEntry ? 'no-entry' : ''}`, ref: containerRef },
        React.createElement(EntryImg, { ref: moveRef, position: defaultPosition, isOs: props.isOs, onDrag: handleDrag, showEntry: showEntry, autoHideEntry: autoHideEntry, visible: visible, onClick: (e) => {
                // 拖拽过程中不触发点击事件
                // if (IsDrag) return;
                onClick?.(e);
                logCustom('CLK_helpEntry', '', panelCode);
            } }, otherEntryNode),
        React.createElement("div", { className: 'cn-ui-intelli-assistant-entry-content', ref: contentRef, style: {
                transform: `translate(0px, ${contentPosition[1]}px)`,
                width: visible ? contentChildWidth : 0,
                visibility: visible ? 'visible' : 'hidden',
            } }, children)));
}
